module.exports = __webpack_public_path__ + "static/media/csv.5bd0b85e.png";